function cookieCnil(){
    if ($.cookie('cookieCnil') === undefined) {
        $('#cookieCnil').fadeIn();

        $(window).click(function () {
            $('#cookieCnil').fadeOut(300);
            $.cookie('cookieCnil', "viewed", {expires: 365});
        });

        $(window).scroll(function () {
            if ($(this).scrollTop() > 1) {
                $('#cookieCnil').fadeOut(300);
                $.cookie('cookieCnil', "viewed", {expires: 365});
            }
        });
    }
}
var slider_array = new Array();

$(document).ready(function(){
    cookieCnil(); // Cookie CNIL

    // launch bxslider
    $('.bxslider').each(function(i){
        slider_array[i] = $(this).bxSlider({
            controls:false,
            adaptiveHeight:true,
            pager:false,
            touchEnabled:false
        });
    });

    // bind controls on custom controls, and run functions on every slider
    $('.slider__controls').bind('click', function(e) {
        e.preventDefault();

        if($(this).hasClass('slider__controls--prev')) {
            $.each(slider_array, function(i,elem){
                elem.goToPrevSlide();
            });

        } else if($(this).hasClass('slider__controls--next')) {
            $.each(slider_array, function(i,elem){
                elem.goToNextSlide();
            });
        }

    });

    $('.scrollspy').affix({
        offset: {
            top: function() {
                return this.top =  $('.scrollspy').offset().top - ($(window).height() / 2) + ( $('.scrollspy').height() / 2);
            },


        }
    });

    $('#slidervertical').carousel({
        interval: 3000
    });

    $('#mapAfricaOld').click(function() {
        if(!$(this).hasClass('active')) {
            $('#mapAfricaNow').removeClass('active');
            $(this).addClass('active');

            $('.map').toggle();
        }
    });

    $('#mapAfricaNow').click(function() {
        if(!$(this).hasClass('active')) {
            $('#mapAfricaOld').removeClass('active');
            $(this).addClass('active');

            $('.map').toggle();
        }
    });

    $('a[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
    });
    $('body').scrollspy({target: ".scrollspy"});

    $('a[href^="#"]').click(function(e) {
        e.preventDefault();

        $("html, body").animate({
            scrollTop: $( $.attr(this, 'href') ).offset().top
        }, "slow");
    });

});


